import { Search, X } from 'lucide-react';
import { useRef, useEffect } from 'react';
import { Input } from './ui/input';

interface SearchBarProps {
  query: string;
  onQueryChange: (query: string) => void;
  onClear: () => void;
  isLoading: boolean;
  interpretation?: string;
}

export function SearchBar({ query, onQueryChange, onClear, isLoading, interpretation }: SearchBarProps) {
  const inputRef = useRef<HTMLInputElement>(null);

  // Focus input on mount
  useEffect(() => {
    inputRef.current?.focus();
  }, []);

  return (
    <div>
      <div className="relative">
        <div className="pointer-events-none absolute inset-y-0 left-0 z-10 flex items-center pl-3">
          {isLoading ? (
            <div className="h-5 w-5 animate-spin rounded-full border-2 border-outline border-t-primary" />
          ) : (
            <Search className="h-5 w-5 text-muted-foreground" />
          )}
        </div>
        <Input
          ref={inputRef}
          type="text"
          value={query}
          onChange={(e) => onQueryChange(e.target.value)}
          placeholder="Search cards... (e.g., pikachu 25 OBF)"
          className="pl-10 pr-10 text-sm"
          autoComplete="off"
          autoCorrect="off"
          autoCapitalize="off"
          spellCheck={false}
        />
        {query && (
          <button
            onClick={onClear}
            className="absolute inset-y-0 right-0 flex items-center pr-3"
          >
            <X className="h-5 w-5 text-muted-foreground hover:text-foreground transition-colors" />
          </button>
        )}
      </div>
      {interpretation && query.length >= 2 && (
        <p className="text-xs text-muted-foreground pl-1 mt-1">
          {interpretation}
        </p>
      )}
    </div>
  );
}
